import React, { useState } from 'react'
import { MDBContainer, MDBRow, 
    MDBCol, MDBBtn, MDBIcon, MDBCollapse, MDBBadge
} from 'mdbreact'
import Fab from '@material-ui/core/Fab';
import Lottie from 'lottie-react-web'
// import aboutAnimation from '../../img/about-animation.json'
import missionAnimation from '../../img/mission-animation.json'
import visionAnimation from '../../img/vision-animation.json'
// import storyAnimation from '../../img/story-animation.json'
import Team from '../Team'
import Loading from '../loaders/Loading'
import Error from '../loaders/Error'
import Markdown from 'markdown-to-jsx';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
//graphql
import { useQuery } from '@apollo/react-hooks'
import ABOUT_PAGE_QUERY from '../../queries/pages/aboutPage'
import Navbar from '../Navbar';
import SEO from '../SEO';
import FooterWhite from '../FooterWhite';
import { HashLink as Link } from 'react-router-hash-link';
import ProgressiveImage from 'react-progressive-image';
import SearchModal from './SearchModal';

const About = () => {
    const [ collapse, setCollapse ] = useState(false);
    const [ show, setShow ] = useState(false);
    const [ search, setSearch ] = useState(false);
    const [ story, setStory ] = useState(false);
    const [roots, setRoots] = useState(false);
    const [identity, setIdentity] = useState(false);

    const { data, loading, error } = useQuery(ABOUT_PAGE_QUERY);

    if(loading) return <Loading/>
    if(error) return <Error/>

    const { introduction, content, Story_Introduction, Story_Content, Conservation_Section, Roots_Section, Identity_Section, teams } = data.aboutPage 

    const conservativeImages = Conservation_Section.carousel.map((image)=> 
        <>
        <ProgressiveImage src={image.url} placeholder={image.formats.thumbnail.url}>
            {(src, loading) => <img src={src} style={{ filter: loading && "blur(10px)" }} alt="" className="w-100"/> }
        </ProgressiveImage>
        </>
    )

    const rootsImages = Roots_Section.carousel.map((image)=> 
        <>
        <ProgressiveImage src={image.url} placeholder={image.formats.thumbnail.url}>
            {(src, loading) => <img src={src} style={{ filter: loading && "blur(10px)" }} alt="" className="w-100"/> }
        </ProgressiveImage>
        </>
    )

    const identityImages = Identity_Section.carousel.map((image)=> 
        <>
        <ProgressiveImage src={image.url} placeholder={image.formats.thumbnail.url}>
            {(src, loading) => <img src={src} style={{ filter: loading && "blur(10px)" }} alt="" className="w-100"/> }
        </ProgressiveImage>
        </>
    )


    return (
        <>
        <SEO title="About Us" description="Everything you need to know about Minimuni."/>
        <Navbar show={search} onClick={()=>setSearch(!search)} page="About Us"/>
        <div style={{ display: search ? "none" : "inline" }} className="wrapper">
        <section className="py-5 grey lighten-4 my-5">
            <MDBContainer id="about-us" className="py-5">
                <h1 className="custom-display menu-mobile-style pb-5 mb-5 font-weight-bold">
                    What is Minimuni?
                </h1>
                <MDBRow>
                    <MDBCol>
                        <p className="mb-4 h3-responsive">
                            {introduction}
                        </p>
                        <MDBCollapse className="mb-4" isOpen={collapse}>
                            <Markdown
                                options={{
                                    overrides: {
                                        h1: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h2: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h3: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h4: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h5: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h6: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        b: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        strong: {
                                            props: {
                                                style: {
                                                    fontWeight: '600'
                                                }
                                            }
                                        },
                                        p: {
                                            props: {
                                                className: "h3-responsive"
                                            }
                                        },
                                        img: {
                                            props: {
                                                className: "w-responsive"
                                            }
                                        }
                                    }
                                }}
                            >
                                {content}
                            </Markdown>
                        </MDBCollapse>
                        <MDBBtn onClick={()=>setCollapse(!collapse)} color={collapse ? "white" : "dark"} className="ml-0 text-capitalize">
                            {collapse ? "read less" : "read more"} <MDBIcon icon="arrow-right ml-2"/>
                        </MDBBtn>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </section>
        <section className="py-lg-5 py-md-5 my-lg-5 my-md-5">
            <h1 className="display-3 menu-mobile-style text-center font-weight-bold text-capitalize mt-5 pt-5 pt-lg-0 pt-md-0 mt-lg-0 mt-md-0">
                Minimuni's Path
            </h1>
            <MDBContainer className="my-5 py-5">
                <MDBRow id="mission">
                    <MDBCol md="6" lg="6">
                        <Lottie options={{ animationData: missionAnimation }}/>
                    </MDBCol>
                    <MDBCol className="align-self-center" md="6" lg="6">
                        <h6 className="font-weight-bold my-4 h6-responsive text-uppercase">
                            <MDBBadge color="dark" className="p-2">
                                Our Mission
                            </MDBBadge>
                        </h6>
                        <p className="h4-responsive">
                            {data.aboutPage.mission}
                        </p>
                    </MDBCol>
                </MDBRow>
                <MDBRow className="my-5 my-lg-0 my-md-0" id="vision">
                    <MDBCol className="align-self-center" md="6" lg="6">
                        <h6 className="font-weight-bold my-4 h6-responsive text-uppercase">
                            <MDBBadge color="dark" className="p-2">
                                Our Vision
                            </MDBBadge>
                        </h6>
                        <p className="h4-responsive">
                            {data.aboutPage.vision}
                        </p>
                    </MDBCol>
                    <MDBCol md="6" lg="6">
                        <Lottie options={{ animationData: visionAnimation }}/>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </section>
        <section className="py-lg-5 my-lg-5 py-md-5 my-md-5">
            <MDBContainer id="story" className="my-lg-5 py-lg-5 my-md-5 py-md-5">
                <h1 className="display-3 mb-5 pb-5 menu-mobile-style font-weight-bold text-capitalize text-center text-md-left text-lg-left">
                    Our Story
                </h1>
                <MDBRow className="text-center text-md-left text-lg-left">
                    <MDBCol md="12" lg="12">
                        <p className="mb-4 h3-responsive">
                            {Story_Introduction}
                        </p>
                        <MDBCollapse className="mb-4" isOpen={story}>
                        <Markdown
                                options={{
                                    overrides: {
                                        h1: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h2: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h3: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h4: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h5: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h6: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        b: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        strong: {
                                            props: {
                                                style: {
                                                    fontWeight: '600'
                                                }
                                            }
                                        },
                                        p: {
                                            props: {
                                                className: "h3-responsive"
                                            }
                                        },
                                        img: {
                                            props: {
                                                className: "w-responsive"
                                            }
                                        }
                                    }
                                }}
                            >
                                {Story_Content}
                            </Markdown> 
                        </MDBCollapse>
                        <a href="#story-reading" onClick={()=>setStory(!story)} className="text-capitalize link-underline h4-responsive m-0">
                            {story ? "Done Reading" : "Continue Reading"} <MDBIcon icon="arrow-right ml-2"/>
                        </a>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </section>
        <section className="py-5 my-5">
            <MDBContainer className="py-5 my-5">
                <h1 className="display-3 mb-5 pb-5 menu-mobile-style font-weight-bold text-capitalize text-center text-md-left text-lg-left">
                    The Three Pillars
                </h1>
                <MDBRow id="conservation" className="pb-5 mb-5">
                    <MDBCol md="8" lg="8">
                        <Carousel autoPlay={5000} infinite stopAutoPlayOnHover dots>
                           {conservativeImages}
                        </Carousel>
                    </MDBCol>
                    <MDBCol md="4" lg="4">
                        <h6 style={{ lineHeight: 4 }} className="font-weight-bold text-uppercase h6-responsive">
                            {Conservation_Section.title}
                        </h6>
                        <h2 className="font-weight-bold mb-4 h2-responsive">
                            {Conservation_Section.introduction}
                        </h2>
                        <MDBCollapse className="mb-4" isOpen={show}>
                            <Markdown
                                options={{
                                    overrides: {
                                        h1: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h2: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h3: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h4: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h5: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h6: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        b: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        strong: {
                                            props: {
                                                style: {
                                                    fontWeight: '600'
                                                }
                                            }
                                        },
                                        p: {
                                            props: {
                                                className: "h5-responsive"
                                            }
                                        },
                                        img: {
                                            props: {
                                                className: "w-responsive"
                                            }
                                        }
                                    }
                                }}
                            >
                            {Conservation_Section.content}
                            </Markdown>
                        </MDBCollapse>
                        <MDBBtn color={show ? "white" : "dark"} onClick={()=>setShow(!show)} className="text-capitalize m-0">
                            {show ? "Done Reading" : "Learn More"}
                        </MDBBtn>
                    </MDBCol>
                </MDBRow>
                <MDBRow id="roots" className="py-5 my-5">
                    <MDBCol md="4" lg="4">
                        <h6 style={{ lineHeight: 4 }} className="font-weight-bold text-uppercase h6-responsive">
                            {Roots_Section.title}
                        </h6>
                        <h2 className="font-weight-bold mb-4 h2-responsive">
                            {Roots_Section.introduction}
                        </h2>
                        <MDBCollapse className="mb-4" isOpen={roots}>
                            <Markdown
                                options={{
                                    overrides: {
                                        h1: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h2: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h3: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h4: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h5: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h6: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        b: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        strong: {
                                            props: {
                                                style: {
                                                    fontWeight: '600'
                                                }
                                            }
                                        },
                                        p: {
                                            props: {
                                                className: "h5-responsive"
                                            }
                                        },
                                        img: {
                                            props: {
                                                className: "w-responsive"
                                            }
                                        }
                                    }
                                }}
                            >
                            {Roots_Section.content}
                            </Markdown>
                        </MDBCollapse>
                        <MDBBtn color={roots ? "white" : "dark"} onClick={()=>setRoots(!roots)} className="text-capitalize m-0 mb-5">
                            {roots ? "Done Reading" : "Learn More"}
                        </MDBBtn>
                    </MDBCol>
                    <MDBCol md="8" lg="8">
                        <Carousel autoPlay={5000} infinite stopAutoPlayOnHover dots>
                            {rootsImages}
                        </Carousel>
                    </MDBCol>
                </MDBRow>
                <MDBRow id="identity" className="pt-5 mt-5">
                    <MDBCol md="8" lg="8">
                        <Carousel autoPlay={5000} infinite stopAutoPlayOnHover dots>
                            {identityImages}
                        </Carousel>
                    </MDBCol>
                    <MDBCol md="4" lg="4">
                        <h6 style={{ lineHeight: 4 }} className="font-weight-bold text-uppercase h6-responsive">
                            {Identity_Section.title}
                        </h6>
                        <h2 className="font-weight-bold mb-4 h2-responsive">
                            {Identity_Section.introduction}
                        </h2>
                        <MDBCollapse className="mb-4" isOpen={identity}>
                            <Markdown
                                options={{
                                    overrides: {
                                        h1: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h2: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h3: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h4: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h5: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        h6: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        b: {
                                            props: {
                                                style: {
                                                    fontWeight: '900'
                                                } 
                                            }
                                        },
                                        strong: {
                                            props: {
                                                style: {
                                                    fontWeight: '600'
                                                }
                                            }
                                        },
                                        p: {
                                            props: {
                                                className: "h5-responsive"
                                            }
                                        },
                                        img: {
                                            props: {
                                                className: "w-responsive"
                                            }
                                        }
                                    }
                                }}
                            >
                            {Identity_Section.content}
                            </Markdown>
                        </MDBCollapse>
                        <MDBBtn color={identity ? "white" : "dark"} onClick={()=>setIdentity(!identity)} className="text-capitalize m-0">
                            {identity ? "Done Reading" : "Learn More"}
                        </MDBBtn>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </section>
            <MDBContainer className="mt-5 mb-5">   
                <MDBContainer className="px-0 py-5 my-5">
                    <h1 className="display-3 menu-mobile-style font-weight-bold text-center my-5 text-capitalize">
                        Our Core Values
                    </h1>
                    <MDBRow className="pt-0 pt-lg-4 pt-md-4">
                        <MDBCol className="mt-4" sm="12" md="4">
                            <div className="values-container z-depth-1 p-4">
                                <div className="values-icon">
                                <Fab className="mt-2 mb-2" color="primary" aria-label="add">
                                    <MDBIcon size="2x" icon="fist-raised" />                                
                                </Fab>
                                </div>
                                <div className="values-title mt-2">
                                    <h4 className="h4-responsive font-weight-bold">
                                        Quality and Assurance
                                    </h4>
                                </div>
                                <div className="values-description">
                                    <p>
                                        We uphold our products to the highest standards of quality and beauty.
                                    </p>
                                </div>
                            </div>
                        </MDBCol>
                        <MDBCol className="mt-4" sm="12" md="4">
                            <div className="values-container z-depth-1 p-4">
                                <div className="values-icon">
                                <Fab className="mt-2 mb-2" color="secondary" aria-label="add">
                                    <MDBIcon size="2x" icon="paint-brush" />                                
                                </Fab>
                                </div>
                                <div className="values-title mt-2">
                                    <h4 className="h4-responsive font-weight-bold">
                                        Creativvity
                                    </h4>
                                </div>
                                <div className="values-description">
                                    <p>
                                        This is the lifeblood of our work.
                                    </p>
                                </div>
                            </div>
                        </MDBCol>
                        <MDBCol className="mt-4" sm="12" md="4">
                            <div className="values-container z-depth-1 p-4">
                                <div className="values-icon">
                                <Fab className="mt-2 mb-2" color="white" aria-label="add">
                                    <MDBIcon className="red-text" size="2x" icon="heart" />                                
                                </Fab>
                                </div>
                                <div className="values-title mt-2">
                                    <h4 className="h4-responsive font-weight-bold">
                                        Passionate 
                                    </h4>
                                </div>
                                <div className="values-description">
                                    <p>
                                        We are passionate about our advocay and how we impact others.
                                    </p>
                                </div>
                            </div>
                        </MDBCol>
                    </MDBRow>
                    <MDBRow className="mt-4 mb-5">
                        <MDBCol className="mt-4" sm="12" md="4">
                            <div className="values-container z-depth-1 p-4">
                                <div className="values-icon">
                                <Fab className="mt-2 mb-2" color="sucess" aria-label="add">
                                    <MDBIcon className="green-text" size="2x" icon="leaf" />                                
                                </Fab>
                                </div>
                                <div className="values-title mt-2">
                                    <h4 className="h4-responsive font-weight-bold">
                                        Green Initiative
                                    </h4>
                                </div>
                                <div className="values-description">
                                    <p>
                                        All life on earth deserve our respect and protection.      
                                    </p>
                                </div>
                            </div>
                        </MDBCol>
                        <MDBCol className="mt-4" sm="12" md="4">
                            <div className="values-container z-depth-1 p-4">
                                <div className="values-icon">
                                <Fab className="mt-2 mb-2" color="primary" aria-label="add">
                                    <MDBIcon size="2x" icon="recycle" />                                
                                </Fab>
                                </div>
                                <div className="values-title mt-2">
                                    <h4 className="h4-responsive font-weight-bold">
                                        Conservative
                                    </h4>
                                </div>
                                <div className="values-description">
                                    <p>
                                        We help in the conservation of our biodiversity by supporting charities with the same goals.
                                    </p>
                                </div>
                            </div>
                        </MDBCol>
                        <MDBCol className="mt-4" sm="12" md="4">
                            <div className="values-container z-depth-1 p-4">
                                <div className="values-icon">
                                <Fab className="mt-2 mb-2" color="secondary" aria-label="add">
                                    <MDBIcon size="2x" icon="flag" />                                
                                </Fab>
                                </div>
                                <div className="values-title mt-2">
                                    <h4 className="h4-responsive font-weight-bold">
                                        Identity
                                    </h4>
                                </div>
                                <div className="values-description">
                                    <p>
                                        We celebrate our Filipino identity.
                                    </p>
                                </div>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
                <MDBContainer id="team" className="my-5 py-5 px-0">
                    <Team teamData={teams}/>
                </MDBContainer>
            </MDBContainer>
            <MDBContainer fluid className="px-0 pt-5">
                <section className="p-5 grey lighten-4">
                    <MDBRow className="py-5 justify-content-center">
                        <MDBCol md="10" lg="8">
                            <div className="text-center">
                                <h2 style={{ lineHeight: 1.5 }} className="h2-responsive font-weight-bold">Got Questions?</h2>
                                <p className="lead">Need more assistance? Don't worry we got your back! Give us a call between 10am - 7pm at +63 919 9239 29. We speak English, Tagalog and Cebuano. Just let us know what you need.</p>
                                <Link smooth to="/contact#contact-us">
                                    <MDBBtn color="dark" className="text-capitalize">
                                        Send Message <MDBIcon fas icon="arrow-right ml-2"/>
                                    </MDBBtn>
                                </Link>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </section>
            </MDBContainer>
            <FooterWhite/>
        </div>
        <SearchModal onClick={()=>setSearch(false)} show={search}/>
        </>
    )
}

export default About
